<template>
  <router-view />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  async created() {
    const userPrefs = this.$userPrefs.init();

    this.$root.$i18n.locale = userPrefs.lang;
    this.setUserPrefLang(userPrefs.lang, false);
    this.$root.$i18n.timeZoneName = userPrefs.timezone;
    this.setUserPrefTimezone(userPrefs.timezone, false);
    await this.getAuthUser();
  },
  methods: {
    ...mapActions("userPrefs", ["setUserPrefLang", "setUserPrefTimezone"]),
    ...mapActions("authentication", ["getAuthUser"]),
  },
  computed: {
    ...mapGetters("authentication", ["token"]),
  },
};
</script>
